"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4543],{

/***/ 28171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kr": function() { return /* binding */ getFeeValue; },
/* harmony export */   "qo": function() { return /* binding */ getOrderCurrency; },
/* harmony export */   "sl": function() { return /* binding */ cancelOrder; }
/* harmony export */ });
/* unused harmony export getCurrencyList */
/* harmony import */ var api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23773);

var cancelOrder = function(param) {
    var orderId = param.orderId, address = param.address, network = param.network;
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].patch */ .ZP.patch("/order/cancel?network=".concat(network), {
        orderId: orderId,
        address: address
    });
};
var getCurrencyList = function(param) {
    var currencyType = param.currencyType;
    return api.get("/order/currency/".concat(currencyType));
};
var getFeeValue = function(param) {
    var network = param.network, contractAddress = param.contractAddress;
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/".concat(network, "/api/v1/asset/").concat(contractAddress));
};
var getOrderCurrency = function(currencyType) {
    return api__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .ZP.get("/order/currency/".concat(currencyType));
};


/***/ }),

/***/ 13851:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Card; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(10166);
// EXTERNAL MODULE: ./node_modules/@playdapp/ui/dist/index.esm.js
var index_esm = __webpack_require__(18722);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/skeleton/dist/chakra-ui-skeleton.esm.js + 1 modules
var chakra_ui_skeleton_esm = __webpack_require__(7983);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useMedia.js
var useMedia = __webpack_require__(94829);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
// EXTERNAL MODULE: ./src/lib/util.ts
var util = __webpack_require__(80871);
// EXTERNAL MODULE: ./src/lib/render-placeholder.ts
var render_placeholder = __webpack_require__(50901);
;// CONCATENATED MODULE: ./src/hooks/useConvertTokenName.ts




var checkCategoryId =  true ? [
    1,
    14
] : 0;
var useConvertTokenName = function(counts, name, collectionsId) {
    var isXxlDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("xxl")));
    var isXlDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("xl")));
    var isLgDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("lg")));
    var isSmDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("sm")));
    var isXsDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)("@media (max-width: 400px)"));
    var isXxsDownScreen = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)("@media (max-width: 359px)"));
    var convertName = (0,react.useMemo)(function() {
        var checkMaxLength = isXsDownScreen || !isLgDownScreen && isXlDownScreen ? 18 : 20;
        var countsIndex = "default";
        if (!name) return "";
        if (name.length < checkMaxLength || !collectionsId || !checkCategoryId.find(function(item) {
            return item === collectionsId;
        }) || isXxsDownScreen || isLgDownScreen && !isXsDownScreen && !isSmDownScreen) {
            return name;
        }
        if (isXsDownScreen) countsIndex = "xsDown";
        else if (isSmDownScreen) countsIndex = "smDown";
        else if (isXlDownScreen) countsIndex = "xlDown";
        else if (isXxlDownScreen) countsIndex = "xxlDown";
        return (0,util/* convertAddress */.US)(name, counts[countsIndex].start, counts[countsIndex].end);
    }, [
        name,
        isXxlDownScreen,
        isXlDownScreen,
        isLgDownScreen,
        isSmDownScreen,
        isXsDownScreen,
        isXxsDownScreen, 
    ]);
    return convertName;
};
/* harmony default export */ var hooks_useConvertTokenName = (useConvertTokenName);

// EXTERNAL MODULE: ./src/hooks/useTimeTracker.ts
var useTimeTracker = __webpack_require__(72319);
// EXTERNAL MODULE: ./src/components/Icon.tsx
var Icon = __webpack_require__(69583);
;// CONCATENATED MODULE: ./src/components/AuctionLabel.tsx





var Label = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e2ulgla0"
})("position:absolute;bottom:0;display:flex;align-items:center;justify-content:center;width:100%;height:32px;background:#fbdaed;box-shadow:0px -1px 4px rgba(0,0,0,0.2);border-bottom-left-radius:8px;border-bottom-right-radius:8px;span{font-size:", index_esm/* fontSize.b4 */.JB.b4, ";color:#da46a6;}span + span{margin-left:", index_esm/* spacing.xxs */.W0.xxs, ";}");
var AuctionLabel = function(param) {
    var _auctionExpireAt = param.auctionExpireAt, auctionExpireAt = _auctionExpireAt === void 0 ? 0 : _auctionExpireAt;
    var ref = (0,useTimeTracker/* default */.Z)(auctionExpireAt), time = ref.time, isEnded = ref.isEnded;
    if (isEnded) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Label, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                name: "alarm",
                size: 18,
                alt: "auction-clock"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Typography */.ZT, {
                type: "b3",
                children: [
                    time.days,
                    "d\xa0",
                    time.hours,
                    "h\xa0",
                    time.minutes,
                    "m\xa0",
                    time.seconds,
                    "s\xa0"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("span", {
                children: "\uD83D\uDD25"
            })
        ]
    });
};
/* harmony default export */ var components_AuctionLabel = (AuctionLabel);

// EXTERNAL MODULE: ./src/components/Image.tsx
var Image = __webpack_require__(97349);
;// CONCATENATED MODULE: ./src/components/Card.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    max-width: ",
        ";\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border: 4px solid ",
        ";\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      opacity: 0.5;\n      cursor: not-allowed;\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      grid-template-columns: repeat(4, 1fr);\n      grid-template-rows: repeat(4, 1fr);\n\n      ",
        ":first-of-type {\n        grid-row-start: 2;\n        grid-row-end: 4;\n        grid-column-start: 1;\n        grid-column-end: 3;\n      }\n\n      ",
        ":last-of-type {\n        grid-row-start: 2;\n        grid-row-end: 4;\n        grid-column-start: 3;\n        grid-column-end: 5;\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}















var containerStyle = /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("display:flex;flex-direction:column;");
var CardLinkBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e141ojx80"
})(containerStyle, ";cursor:pointer;z-index:0;");
var CardButtonBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx81"
})(containerStyle, ";");
var ItemImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx82"
})("overflow:hidden;position:relative;border-radius:16px;border:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";transition:transform 0.2s ease-in-out;backface-visibility:hidden;&::after{content:'';display:block;padding-bottom:100%;}", index_esm/* breakpoints.down */.AV.down("sm"), "{border-radius:8px;}& > span{border-radius:8px;}& > span > img,& > img,& > video{transition:transform 0.2s ease-in-out;transform:scale(1);position:absolute;width:100%;height:100%;object-fit:contain;z-index:1;}");
var PlayIconBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx83"
})("position:absolute;bottom:0px;right:8px;z-index:2;");
var SkeletonImageBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx84"
})("overflow:hidden;position:relative;border-radius:16px;.chakra-skeleton::after{content:'';display:block;padding-bottom:100%;}", index_esm/* breakpoints.down */.AV.down("sm"), "{border-radius:8px;}");
var CardBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx85"
})("position:relative;width:100%;box-shadow:0px 4px 8px rgba(30,31,36,0.15);border-radius:16px;padding:", index_esm/* spacing.s */.W0.s, ";transition:all 0.2s ease-in-out;z-index:0;", function(param) {
    var maxWidth = param.maxWidth;
    return (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), maxWidth);
}, " ", function(param) {
    var isSelectable = param.isSelectable, isActive = param.isActive;
    return isSelectable && (0,emotion_react_browser_esm/* css */.iv)(_templateObject1(), isActive ? index_esm/* palette.marketplace */.DG.marketplace : index_esm/* palette.gray600 */.DG.gray600);
}, "  &:hover{box-shadow:0px 4px 8px rgba(30,31,36,0.25);", ItemImageBox, " > img,", ItemImageBox, " > span > img,", ItemImageBox, " > video{transform:scale(\n        ", function(param) {
    var hasImage = param.hasImage, disabled = param.disabled;
    return hasImage && !disabled ? 1.15 : 1;
}, "      );}}", function(param) {
    var disabled = param.disabled;
    return disabled && (0,emotion_react_browser_esm/* css */.iv)(_templateObject2());
}, " ", index_esm/* breakpoints.down */.AV.down("md"), "{padding:", index_esm/* spacing.xs */.W0.xs, ";border-radius:12px;}");
var TopStatusBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx86"
})("display:flex;justify-content:space-between;align-items:center;margin-bottom:", index_esm/* spacing.xs */.W0.xs, ";", index_esm/* breakpoints.down */.AV.down("md"), "{margin-bottom:", function(param) {
    var theme = param.theme;
    return theme.rem(6);
}, ";}& > span{flex:none;border-radius:50%;}");
var CollectionTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx87"
})("display:flex;align-items:center;max-width:80%;padding:", index_esm/* spacing.xxs */.W0.xxs, " ", index_esm/* spacing.xs */.W0.xs, " ", index_esm/* spacing.xxs */.W0.xxs, " ", index_esm/* spacing.xxs */.W0.xxs, ";border:1px solid ", index_esm/* palette.gray300 */.DG.gray300, ";border-radius:11px;", index_esm/* breakpoints.down */.AV.down("md"), "{max-width:60%;}& > span{flex:none;border-radius:50%;}");
var CollectionTagText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e141ojx88"
})("overflow:hidden;margin-left:", index_esm/* spacing.xxs */.W0.xxs, ";font-size:", index_esm/* fontSize.p6 */.JB.p6, ";color:", index_esm/* palette.dgray300 */.DG.dgray300, ";line-height:1.4;text-overflow:ellipsis;white-space:nowrap;");
var EmptyStatusBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx89"
})("width:100%;height:1.5rem;", index_esm/* breakpoints.down */.AV.down("md"), "{max-width:60%;}");
var BundleItemImageBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx810"
})("position:relative;display:grid;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat(2,1fr);flex:none;grid-gap:", index_esm/* spacing.xxs */.W0.xxs, ";align-items:center;", function(param) {
    var imageCount = param.imageCount;
    return imageCount === 2 && (0,emotion_react_browser_esm/* css */.iv)(_templateObject3(), ItemImageBox, ItemImageBox);
});
var BundleMoreImageBadge = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx811"
})("position:absolute;bottom:", index_esm/* spacing.xs */.W0.xs, ";right:", index_esm/* spacing.xs */.W0.xs, ";display:flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:rgba(255,255,255,0.9);font-size:", index_esm/* fontSize.p6 */.JB.p6, ";line-height:1.5;color:", index_esm/* palette.black */.DG.black, ";filter:drop-shadow(0px 4px 8px rgba(30,31,36,0.15));z-index:2;");
var EmptyImageOverlay = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx812"
})("position:absolute;top:0;left:0;display:flex;flex-direction:column;justify-content:center;align-items:center;width:calc(100% + 0.125rem);height:calc(100% + 0.125rem);flex-direction:column;justify-content:center;border-radius:16px;backdrop-filter:blur(24px);z-index:2;backface-visibility:hidden;");
var RefreshIcon = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx813"
})("display:flex;align-items:center;justify-content:center;flex:none;width:36px;height:36px;border:1px solid ", index_esm/* palette.white */.DG.white, ";border-radius:50%;", index_esm/* breakpoints.down */.AV.down("md"), "{width:32px;height:32px;& > span,& > span > img{width:16px !important;height:16px !important;}}");
var EmptyImageOverlayText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e141ojx814"
})("margin:", index_esm/* spacing.xs */.W0.xs, " ", index_esm/* spacing.xl */.W0.xl, " 0 ", index_esm/* spacing.xl */.W0.xl, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:400;line-height:1.5;color:", index_esm/* palette.white */.DG.white, ";text-align:center;", index_esm/* breakpoints.down */.AV.down("lg"), "{font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}");
var TokenNameBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx815"
})("margin-top:", index_esm/* spacing.xs */.W0.xs, ";.chakra-skeleton{border-radius:8px;}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(6);
}, ";}");
var TokenNameText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e141ojx816"
})("overflow:hidden;font-size:", index_esm/* fontSize.b3 */.JB.b3, ";font-weight:600;line-height:1.5;color:", index_esm/* palette.black */.DG.black, ";text-overflow:ellipsis;white-space:nowrap;", index_esm/* breakpoints.down */.AV.down("lg"), "{font-size:", index_esm/* fontSize.b4 */.JB.b4, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}");
var TokenPriceBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx817"
})("display:flex;align-items:center;width:100%;margin-top:", index_esm/* spacing.xxs */.W0.xxs, ";.chakra-skeleton{border-radius:8px;}");
var TokenPriceTextBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx818"
})("width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;");
var TokenPriceText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e141ojx819"
})("color:", index_esm/* palette.black */.DG.black, ";font-size:", index_esm/* fontSize.b4 */.JB.b4, ";font-weight:600;", index_esm/* breakpoints.down */.AV.down("lg"), "{font-size:", index_esm/* fontSize.b5 */.JB.b5, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.b6 */.JB.b6, ";}");
var TokenLikeBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx820"
})("display:flex;align-items:center;width:100%;margin-top:", index_esm/* spacing.xxs */.W0.xxs, ";");
var TokenLikeText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e141ojx821"
})("margin-left:", index_esm/* spacing.xxs */.W0.xxs, ";color:", index_esm/* palette.dgray100 */.DG.dgray100, ";", (0,index_esm/* fontStyle */.p_)("p4"), ";", index_esm/* breakpoints.down */.AV.down("lg"), "{", (0,index_esm/* fontStyle */.p_)("p5"), ";}", index_esm/* breakpoints.down */.AV.down("md"), "{", (0,index_esm/* fontStyle */.p_)("p6"), ";}");
var TokenNotSaleText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e141ojx822"
})("color:", index_esm/* palette.gray900 */.DG.gray900, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:400;", index_esm/* breakpoints.down */.AV.down("lg"), "{font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.p6 */.JB.p6, ";}");
var ConvertPriceText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e141ojx823"
})("margin-left:", function(param) {
    var theme = param.theme;
    return theme.rem(6);
}, ";color:", index_esm/* palette.dgray100 */.DG.dgray100, ";font-size:", index_esm/* fontSize.p4 */.JB.p4, ";font-weight:400;", index_esm/* breakpoints.down */.AV.down("lg"), "{width:auto;font-size:", index_esm/* fontSize.p5 */.JB.p5, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{font-size:", index_esm/* fontSize.p6 */.JB.p6, ";}");
var ButtonStatusBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx824"
})("display:flex;flex-direction:row-reverse;justify-content:space-between;align-items:center;margin-top:", index_esm/* spacing.s */.W0.s, ";", index_esm/* breakpoints.down */.AV.down("lg"), "{margin-top:", index_esm/* spacing.xs */.W0.xs, ";}", index_esm/* breakpoints.down */.AV.down("md"), "{margin-top:", function(param) {
    var theme = param.theme;
    return theme.rem(6);
}, ";}");
var SaleStatusText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e141ojx825"
})("width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;order:2;font-size:", index_esm/* fontSize.p6 */.JB.p6, ";color:", function(param) {
    var color = param.color;
    return color || index_esm/* palette.dgray100 */.DG.dgray100;
}, ";");
var SaleStatusPriceText = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("span", {
    target: "e141ojx826"
})("font-weight:600;");
var NetworkStatusBlock = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx827"
})("width:18px;height:18px;margin-left:", index_esm/* spacing.xs */.W0.xs, ";");
var SelectCheckBox = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e141ojx828"
})("position:absolute;top:50%;left:50%;display:flex;justify-content:center;align-items:center;transform:translate(-50%,-50%);width:72px;height:72px;border-radius:50%;background-color:", function(param) {
    var isActive = param.isActive;
    return isActive ? index_esm/* palette.primary500 */.DG.primary500 : index_esm/* palette.gray900 */.DG.gray900;
}, ";box-shadow:0px 4px 4px rgba(0,0,0,0.5);z-index:2;", index_esm/* breakpoints.down */.AV.down("md"), "{width:48px;height:48px;& > span,& > span > img{width:24px !important;height:24px !important;}}");
var isVideoPlayClicked = false;
var convertCounts = {
    default: {
        start: 6,
        end: 12
    },
    xxlDown: {
        start: 5,
        end: 12
    },
    xlDown: {
        start: 4,
        end: 12
    },
    smDown: {
        start: 8,
        end: 12
    },
    xsDown: {
        start: 4,
        end: 13
    }
};
var CardElementWrapper = function(param) {
    var children = param.children, href = param.href, isSelectable = param.isSelectable, isLoading = param.isLoading, tokenId = param.tokenId, collectionInfo = param.collectionInfo, imageUri = param.imageUri, name = param.name, attributes = param.attributes, assetAddress = param.assetAddress, disabled = param.disabled, onClick = param.onClick;
    var router = (0,next_router.useRouter)();
    var handleClickCheck = function(href) {
        if (isVideoPlayClicked) {
            isVideoPlayClicked = false;
            return;
        }
        router.push(href || "/");
    };
    if (isLoading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
            children: children
        });
    }
    if (isSelectable) return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardButtonBlock, {
        role: "button",
        tabIndex: 0,
        onClick: function() {
            if (isVideoPlayClicked) {
                isVideoPlayClicked = false;
                return;
            }
            if (onClick) {
                onClick(tokenId, collectionInfo, imageUri, name, attributes, assetAddress, disabled)();
            }
        },
        children: children
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardLinkBlock, {
        onClick: function() {
            return handleClickCheck(href);
        },
        children: children
    });
};
/**
 * NFT 정보에 대한 카드 컴포넌트
 */ var Card = /*#__PURE__*/ react.forwardRef(function(param, ref) {
    var collectionInfo = param.collectionInfo, imageUri = param.imageUri, animationUri = param.animationUri, tokenId = param.tokenId, name = param.name, order = param.order, convertedPrice = param.convertedPrice, network = param.network, href = param.href, assetAddress = param.assetAddress, attributes = param.attributes, maxWidth = param.maxWidth, like = param.like, isOwner = param.isOwner, isSelectable = param.isSelectable, isActive = param.isActive, isLoading = param.isLoading, disabled = param.disabled, isBundle = param.isBundle, onClick = param.onClick;
    var _$ref;
    var playIconBoxElement = (0,react.useRef)(null);
    var isMobile = (0,useMedia/* default */.Z)((0,util/* getBreakpointQuery */.XR)(index_esm/* breakpoints.down */.AV.down("sm")));
    var _$ref1 = (0,react.useState)(false), isVideoPlay = _$ref1[0], setIsVideoPlay = _$ref1[1];
    var _$ref2 = (0,react.useState)(false), isVideoPlayHover = _$ref2[0], setIsVideoPlayHover = _$ref2[1];
    var _$ref3 = (0,react.useState)(false), isVideoError = _$ref3[0], setIsVideoError = _$ref3[1];
    var _$ref4 = (0,react.useState)(false), isImageError = _$ref4[0], setIsImageError = _$ref4[1];
    var _$ref5 = (0,react.useState)([
        false,
        false,
        false,
        false, 
    ]), isBundleVideoError = _$ref5[0], setIsBundleVideoError = _$ref5[1];
    var _$ref6 = (0,react.useState)([
        false,
        false,
        false,
        false, 
    ]), isBundleImageError = _$ref6[0], setIsBundleImageError = _$ref6[1];
    var convertName = hooks_useConvertTokenName(convertCounts, name, collectionInfo === null || collectionInfo === void 0 ? void 0 : collectionInfo.categoryId);
    var imageInfo = (0,react.useMemo)(function() {
        if (!imageUri && !animationUri) {
            return {
                isGifImage: false,
                showImageType: "error"
            };
        }
        var isGifImage = typeof imageUri === "string" && /\.(gif)$/i.test(imageUri);
        if (!isGifImage && animationUri && isVideoPlay) {
            return {
                isGifImage: isGifImage,
                showImageType: "video"
            };
        }
        return {
            isGifImage: isGifImage,
            showImageType: "image"
        };
    }, [
        imageUri,
        animationUri,
        isVideoPlay
    ]);
    var handleVideoPlayClick = function() {
        isVideoPlayClicked = true;
        setIsVideoPlay(!isVideoPlay);
    };
    // image 검사
    (0,react.useEffect)(function() {
        if (typeof imageUri === "string") {
            if (!/\.(gif|jpe?g|tiff?|png|webp|bmp|mp4|mov)$/i.test(imageUri)) {
                (0,_async_to_generator/* default */.Z)(function() {
                    var res;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    axios_default().get(imageUri)
                                ];
                            case 1:
                                res = _state.sent();
                                if (!/image/i.test(res.headers["content-type"])) {
                                    setIsImageError(true);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        } else if (imageUri && typeof imageUri === "object") {
            var requestList = imageUri.map(function(image, index) {
                if (!/\.(gif|jpe?g|tiff?|png|webp|bmp|mp4|mov)$/i.test(image)) {
                    return (0,_async_to_generator/* default */.Z)(function() {
                        var res;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        axios_default().get(image)
                                    ];
                                case 1:
                                    res = _state.sent();
                                    if (!/image/i.test(res.headers["content-type"])) {
                                        setIsBundleImageError(function(prevState) {
                                            return (0,_to_consumable_array/* default */.Z)(prevState.slice(0, index)).concat([
                                                true, 
                                            ], (0,_to_consumable_array/* default */.Z)(prevState.slice(index + 1)));
                                        });
                                    }
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
                return new Promise(function(resolve) {
                    return resolve;
                });
            });
            Promise.all(requestList);
        }
    }, [
        imageUri
    ]);
    (0,react.useEffect)(function() {
        if (!playIconBoxElement.current) return;
        var playIconBox = playIconBoxElement.current;
        playIconBox.addEventListener("mouseenter", function() {
            setIsVideoPlayHover(true);
        });
        playIconBox.addEventListener("mouseleave", function() {
            setIsVideoPlayHover(false);
        });
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardElementWrapper, {
        isSelectable: isSelectable,
        isLoading: isLoading,
        href: href,
        tokenId: tokenId,
        collectionInfo: collectionInfo,
        imageUri: imageUri,
        name: name,
        like: like,
        assetAddress: assetAddress,
        disabled: disabled,
        attributes: attributes,
        onClick: onClick,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardBlock, {
            isSelectable: isSelectable,
            isActive: isActive,
            disabled: disabled,
            maxWidth: maxWidth,
            hasImage: !!imageUri,
            ref: ref,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TopStatusBlock, {
                    children: [
                        isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                                    width: "50%",
                                    height: "24px",
                                    borderRadius: 24
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* SkeletonCircle */.s7, {
                                    size: "24px"
                                })
                            ]
                        }),
                        !isLoading && collectionInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CollectionTag, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                    src: collectionInfo.thumbnailUrl,
                                    alt: "card-collection-thumb",
                                    width: 14,
                                    height: 14
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectionTagText, {
                                    children: collectionInfo.title
                                })
                            ]
                        }),
                        !isLoading && collectionInfo && isOwner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                            name: "my",
                            size: 20
                        }),
                        !isLoading && !collectionInfo && !isOwner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyStatusBlock, {}),
                        !isLoading && !collectionInfo && isOwner && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyStatusBlock, {}),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                    name: "my",
                                    size: 20
                                })
                            ]
                        })
                    ]
                }),
                isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SkeletonImageBox, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                        width: "100%",
                        height: "100%"
                    })
                }),
                !isLoading && (imageInfo.showImageType === "error" || isImageError || isVideoError) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemImageBox, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                            src: (collectionInfo === null || collectionInfo === void 0 ? void 0 : collectionInfo.thumbnailUrl) || "https://images.playdapp.com/marketplace-dev/collections/placeholder2v.png",
                            alt: "card-thumb",
                            layout: "fill"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyImageOverlay, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RefreshIcon, {
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                        name: "refresh-white",
                                        size: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyImageOverlayText, {
                                    children: "Content not available yet"
                                })
                            ]
                        })
                    ]
                }),
                !isLoading && !isImageError && !isVideoError && imageInfo.showImageType !== "error" && typeof imageUri !== "object" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemImageBox, {
                    children: [
                        imageInfo.showImageType === "image" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                            src: imageUri,
                            alt: "token",
                            layout: "fill",
                            onError: (0,render_placeholder/* renderFungibleImage */.y)((collectionInfo === null || collectionInfo === void 0 ? void 0 : collectionInfo.thumbnailUrl) || "https://images.playdapp.com/marketplace-dev/collections/placeholder2v.png"),
                            unoptimized: true
                        }),
                        imageInfo.showImageType === "video" && isVideoPlay && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                            src: animationUri,
                            poster: typeof imageUri === "string" ? imageUri : undefined,
                            muted: true,
                            loop: true,
                            playsInline: true,
                            autoPlay: true,
                            onError: function() {
                                setIsVideoError(true);
                            }
                        }),
                        typeof animationUri === "string" && !imageInfo.isGifImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PlayIconBox, {
                            ref: playIconBoxElement,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                name: "video-".concat(isVideoPlay ? "stop" : "play").concat(isVideoPlayHover ? "-hover" : ""),
                                size: isMobile ? 24 : 40,
                                onClick: handleVideoPlayClick
                            })
                        }),
                        (order === null || order === void 0 ? void 0 : order.auction) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(components_AuctionLabel, {
                            auctionExpireAt: order.auction.expireAt
                        })
                    ]
                }),
                !isLoading && imageUri && typeof imageUri === "object" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BundleItemImageBlock, {
                    imageCount: imageUri.length,
                    children: [
                        imageUri.slice(0, 4).map(function(image, index) {
                            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ItemImageBox, {
                                children: [
                                    image && !isBundleVideoError[index] && (/.(mp4|mov)$/.test(image) ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("video", {
                                        src: image,
                                        muted: true,
                                        autoPlay: true,
                                        loop: true,
                                        playsInline: true,
                                        onError: function() {
                                            setIsBundleVideoError(function(prevState) {
                                                return (0,_to_consumable_array/* default */.Z)(prevState.slice(0, index)).concat([
                                                    true, 
                                                ], (0,_to_consumable_array/* default */.Z)(prevState.slice(index + 1)));
                                            });
                                        }
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                        src: image,
                                        alt: "",
                                        layout: "fill",
                                        onError: (0,render_placeholder/* renderFungibleImage */.y)((collectionInfo === null || collectionInfo === void 0 ? void 0 : collectionInfo.thumbnailUrl) || "https://images.playdapp.com/marketplace-dev/collections/placeholder2v.png"),
                                        unoptimized: true
                                    })),
                                    (!image || isBundleVideoError[index] || isBundleImageError[index]) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
                                                prefix: "s3",
                                                src: "/collections/placeholder2v.png",
                                                alt: "card-thumb",
                                                layout: "fill"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(EmptyImageOverlay, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RefreshIcon, {
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                                            name: "refresh-white",
                                                            size: 20
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EmptyImageOverlayText, {
                                                        children: "Content not available yet"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, "".concat(image, "-").concat(index));
                        }),
                        imageUri.length > 4 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(BundleMoreImageBadge, {
                            children: [
                                "+",
                                imageUri.length - 4
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TokenNameBlock, {
                    children: [
                        isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                            width: "70%",
                            height: "24px"
                        }),
                        !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TokenNameText, {
                            children: [
                                convertName && convertName,
                                !convertName && tokenId && tokenId,
                                !convertName && !tokenId && "-"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TokenPriceBlock, {
                    children: [
                        isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                            width: "80%",
                            height: "20px"
                        }),
                        !isLoading && order && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TokenPriceTextBlock, {
                            children: order.sale ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TokenPriceText, {
                                children: [
                                    (_$ref = order.sale.price) === null || _$ref === void 0 ? void 0 : _$ref.toLocaleString(undefined, {
                                        maximumFractionDigits: 4
                                    }),
                                    " ",
                                    order.sale.currency,
                                    convertedPrice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ConvertPriceText, {
                                        children: [
                                            "(≈ $",
                                            convertedPrice,
                                            ")"
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TokenNotSaleText, {
                                children: "Not for sale"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TokenLikeBlock, {
                    children: [
                        isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                            width: "80%",
                            height: "20px"
                        }),
                        !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                    name: isBundle ? "heart-bundle-gray" : "heart-single-gray",
                                    size: isBundle ? 24 : 14.96
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TokenLikeText, {
                                    children: like || "0"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(ButtonStatusBlock, {
                    children: [
                        isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* SkeletonCircle */.s7, {
                                    size: "20px"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_skeleton_esm/* Skeleton */.Od, {
                                    width: "50%",
                                    height: "20px",
                                    borderRadius: 24
                                })
                            ]
                        }),
                        !isLoading && order && (order === null || order === void 0 ? void 0 : order.lastSoldInfo) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SaleStatusText, {
                            color: "#9D740C",
                            children: [
                                "Last sold ",
                                !isMobile && "for",
                                "\xa0",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SaleStatusPriceText, {
                                    children: [
                                        order === null || order === void 0 ? void 0 : order.lastSoldInfo.price,
                                        " ",
                                        order === null || order === void 0 ? void 0 : order.lastSoldInfo.currency
                                    ]
                                })
                            ]
                        }),
                        !isLoading && order && !(order === null || order === void 0 ? void 0 : order.lastSoldInfo) && order.offer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SaleStatusText, {
                            color: "#1766F9",
                            children: [
                                "Offer ",
                                !isMobile && "for",
                                "\xa0",
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(SaleStatusPriceText, {
                                    children: [
                                        order.offer.highestOfferPrice,
                                        " ",
                                        order.offer.highestOfferCurrency
                                    ]
                                })
                            ]
                        }),
                        !isLoading && network && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NetworkStatusBlock, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                                name: "brand-".concat(network),
                                width: 16,
                                height: 14
                            })
                        })
                    ]
                }),
                !isLoading && isSelectable && !disabled && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SelectCheckBox, {
                    isActive: isActive,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Icon/* default */.Z, {
                        name: "selected".concat(isActive ? "-primary100" : ""),
                        size: 32,
                        alt: "selected-large"
                    })
                })
            ]
        })
    });
});
var areEqual = function(prevProps, nextProps) {
    if (!!prevProps.isSelectable || !!nextProps.isSelectable) return false;
    return prevProps.tokenId === nextProps.tokenId;
};
/* harmony default export */ var components_Card = (/*#__PURE__*/react.memo(Card, areEqual));


/***/ }),

/***/ 72319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var lib_util__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80871);


var useTimeTracker = function() {
    var endTime = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
    }), time = ref[0], setTime = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(endTime), timestamp = ref1[0], setTimeStamp = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), isEnded = ref2[0], setIsEnded = ref2[1];
    var updateTimeStamp = function(time) {
        setTimeStamp(time);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (timestamp) {
            setIsEnded(false);
            var id = setInterval(function() {
                var timeRemain = (0,lib_util__WEBPACK_IMPORTED_MODULE_1__/* .getTimeRemain */ .fy)(timestamp);
                if (timeRemain) {
                    var days = timeRemain.days, hours = timeRemain.hours, minutes = timeRemain.minutes, seconds = timeRemain.seconds;
                    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) setIsEnded(true);
                    setTime({
                        days: days,
                        hours: hours.toString().padStart(2, "0"),
                        minutes: minutes.toString().padStart(2, "0"),
                        seconds: seconds.toString().padStart(2, "0")
                    });
                }
            }, 1000);
            return function() {
                clearInterval(id);
            };
        }
    }, [
        timestamp
    ]);
    return {
        time: time,
        isEnded: isEnded,
        updateTimeStamp: updateTimeStamp
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useTimeTracker);


/***/ })

}]);